<template>
  <SignInTemplateComponent
    :left-title="$t('Views.user_signup.left_side.title')"
    :left-subtitle="$t('Views.user_signup.left_side.subtitle')"
    :left-image="assets.signup_business_left_image"
    :logo-desktop="assets.signup_logo_white"
    :logo-mobile="assets.signup_logo_black"
  >
    <span v-show="!loading">
      <span
        v-if="lastUsedUsername && !useOtherAccount"
        class="SignInView__autologin"
      >
        <form>
          <MuiButtonFlat
            full-width
            @click.native="autoLogin"
          >
            {{ lastUsedUsername }}
          </MuiButtonFlat>
          <MuiButtonLink
            full-width
            @click.native="enterWithOtherAccount"
          >
            use other account
          </MuiButtonLink>
        </form>
      </span>
      <span
        v-else
        class="SignInView__login"
      >
        <MuiForm
          v-model="formData"
          class="Step__form"
          @submit.native="submit"
        >
          <h1 class="font-normal m-m-b full-width">Sign in</h1>

          <MuiInputText
            :full-width="true"
            :required="true"
            :value="fieldState.email"
            :on-change="(e, v) => updateEmail(v)"
            label="Email"
            placeholder="email"
            type="text"
            name="email"
          />

          <MuiInputText
            :full-width="true"
            :required="true"
            :value="fieldState.password"
            :on-change="(e, v) => updatePassword(v)"
            label="Password"
            placeholder="password"
            type="password"
            name="password"
          />

          <div class="d-flex">
            <MuiButtonLink
              v-if="lastUsedUsername"
              class="Step__form__next-button m-s-b"
              @click.native="useOtherAccount = !useOtherAccount"
            >
              Current session
            </MuiButtonLink>

            <MuiButtonFlat
              :submit="true"
              class="Step__form__next-button m-s-b"
            >
              Sign in
            </MuiButtonFlat>
          </div>
        </MuiForm>
      </span>
    </span>
  </SignInTemplateComponent>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import {
  MuiForm, MuiInputText, MuiButtonFlat, MuiButtonLink,
} from '@ubeeqo/motion-ui';

import { Auth } from '@/main';
import SignInTemplateComponent from './SignInTemplateComponent';

export default {
  name: 'SignInView',
  components: {
    SignInTemplateComponent,
    MuiForm,
    MuiInputText,
    MuiButtonFlat,
    MuiButtonLink,
  },
  data() {
    return {
      Auth: null,
      currentSession: null,
      authenticated: false,
      formData: {},
      lastUsedUsername: null,
      useOtherAccount: false,
      loading: true,
    };
  },
  computed: {
    ...mapState('SignIn', {
      fieldState: state => state,
    }),
    ...mapState('Setup', {
      assets: state => state.assets,
    }),
  },
  created() {
    Auth.auth0.client.getSSOData((err, { lastUsedUsername }) => {
      this.lastUsedUsername = lastUsedUsername;
      this.loading = false;
    });

    Auth.auth0.checkSession({
      scope: 'read:current_user',
    }, () => {});
  },
  methods: {
    ...mapMutations('SignIn', [
      'updateEmail',
      'updatePassword',
    ]),
    submit(e) {
      e.stopPropagation();
      const { email, password } = this.fieldState;
      if (!email || !password) {
        return;
      }

      Auth.auth0.login({
        username: email,
        password,
      }, ({ code }) => {
        if (code === 'access_denied') {
          this.$notifications.create({
            delayToClose: 3000,
            text: 'Access denied',
            textAction: 'Close',
            type: 'danger',
          });
          this.updatePassword('');
        }
      });
    },
    autoLogin(e) {
      Auth.resetSession();
      e.stopPropagation();
    },
    enterWithOtherAccount(e) {
      e.stopPropagation();
      this.useOtherAccount = !this.useOtherAccount;
    },
  },
};
</script>
